import React, { useState } from "react";
import { SearchBar, Button } from "../../../../common/APICommon";
import AddIcon from '@mui/icons-material/Add';
import EmployeeTypeTable from "./components/EmployeeTypeTable";
import EmployeeTypeAddEditModal from "./components/EmployeeTypeAddEditModal";

const EmployeeTypeModule = ({ data, handleFilter, createEmployeeType, updateEmployeeType }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [mode, setMode] = useState("add");

  const openAdd = () => {
    setSelectedItem(null);
    setMode("add");
    setIsModalOpen(true);
  };

  const openEdit = (item) => {
    setSelectedItem(item);
    setMode("edit");
    setIsModalOpen(true);
  };

  const handleSave = async (formData) => {
    let res;
    if (mode === "edit") {
      res = await updateEmployeeType(selectedItem.id, formData, selectedItem);
    } else {
      res = await createEmployeeType(formData);
    }
    if (res.success) setIsModalOpen(false);
  };

  return (
    <>
      <div className='p-4 space-y-4'>
        <SearchBar handleFilter={handleFilter} />
        <Button
          icon={<AddIcon />}
          name={"Add Employee Type"}
          className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
          onClick={openAdd}
        />

        <EmployeeTypeTable
          data={data}
          onEdit={openEdit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />

      </div>

      <EmployeeTypeAddEditModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedItem={selectedItem}
        onSave={handleSave}
        mode={mode}
      />
    </>
  );
};

export default EmployeeTypeModule;